import R from 'ramda';
import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  getRoleNames,
  getOwnershipTypeName,
  getWorkTypeNameById,
  getSubWorkTypeNameById,
  getMemberByUserId,
  getMemberNameByUserId,
} from '../../utils';
import AgreementSection from './AgreementSection';
import { selectDealBlocksState } from '../../redux/selectors';
import getContent from '../ContractBlock/Contents';
import { PublishesID } from '../../constants';
import getState from '../Deals/DealEditPages/helpers/getState';

class AgreementTextPremiumSplit extends Component {
  renderWorks() {
    let { works, workTypes, subWorkTypes, type, tabName } = this.props;
    let workTypeName = '';
    let subWorkTypeName = '';

    if (works.length) {
      if (type === 'agreement-detail') {
        works = R.filter((work) => work.date_accepted, works);
      }

      return works.map((work, i) => {
        let withPublishers = false;

        if (work.type) {
          workTypeName = getWorkTypeNameById(work.type, workTypes);
          withPublishers = workTypeName === 'Music';
        }
        if (work.sub_type) {
          subWorkTypeName = getSubWorkTypeNameById(work.sub_type, subWorkTypes);
        }

        const notAccepted = !work.date_accepted;
        const isAmmend = type === 'agreement-detail' ? i > 0 : true;
        const blockSelected =
          tabName === 'Overview' ||
          tabName === 'Publishers' ||
          tabName === 'LicensingPermissions';

        return (
          <div
            key={i}
            className={`${notAccepted ? 'work-not-accepted' : ''} ${
              blockSelected ? 'block-selected' : ''
            }`}
          >
            <p>
              <label>
                <label className="fixed">Work:</label>
                {work.name}
              </label>
              <br />
              <label>
                <label className="fixed">Type of Work:</label>
                {workTypeName}, {subWorkTypeName}
              </label>
              <br />
              <label>
                <label className="fixed">Date:</label>
                {moment(work.date_created).format('MM/DD/YYYY')}
              </label>
            </p>
            {this.renderWorkOwnership(work, withPublishers, isAmmend)}
          </div>
        );
      });
    }
  }

  renderWorkOwnership(work, withPublishers, isAmmend) {
    const {
      type,
      roles,
      agreement,
      ownershipTypes,
      contractBlocks,
      dealBlocks,
      profile,
      fields,
      deal: dealOrigin,
      dealUsers: dealUsersOrigin,
      isTestVersion,
      members,
    } = this.props;

    let licenserIds = agreement.licenser_ids || [];
    const deals = agreement.deals || [];
    const block = R.find(R.propEq('name', 'Licensing Permissions'))(
      contractBlocks
    );

    if (block && block.options) {
      licenserIds = block.options.licenserIds || [];
    }

    if (work.work_ownership_info && work.work_ownership_info.length) {
      const ownerships = R.clone(work.work_ownership_info);

      let deal = R.find(R.propEq('work', work.id))(deals);
      let dealUsers = [];
      if (deal) {
        dealUsers = deal.deal_users || [];
      }

      if (
        type === 'deal-edit' &&
        dealBlocks &&
        dealOrigin &&
        deal &&
        deal.id === dealOrigin.id
      ) {
        // when it's deal work, find deal changes for Overview
        let dealBlock = R.find(R.propEq('id', 0))(dealBlocks);

        if (dealBlock && dealBlock.changes && isTestVersion) {
          dealBlock.changes.forEach((change) => {
            if (change) {
              const index = R.findIndex(R.propEq('id', change.id))(ownerships);
              if (index !== -1) {
                let ownership = { ...ownerships[index] };

                if (change.role_ids) {
                  ownership.role_ids = change.role_ids;
                }
                if (change.ownership_type) {
                  ownership.ownership_type = change.ownership_type;
                }
                if (
                  change.percentage !== undefined &&
                  ownerships.percentage !== change.percentage
                ) {
                  ownership.percentage = change.percentage;
                }

                ownerships[index] = ownership;
              }
            }
          });
        }

        // find deal changes for licensing
        dealBlock = R.find(R.propEq('id', block.id))(dealBlocks);
        if (dealBlock && dealBlock.changes && isTestVersion) {
          licenserIds = dealBlock.changes.licenserIds || [];
        }
      }

      let dateEffect = '';
      if (work.date_accepted) {
        dateEffect = moment(work.date_accepted).format('MMM/DD/YYYY');
      }

      const rows = [];
      let i = 0;

      ownerships.forEach(
        ({
          user,
          ownership_type,
          percentage,
          role_ids,
          use_company_name,
          company_name,
          ...otherInfo
        }) => {
          let userName = getMemberNameByUserId(user, members);

          // if (agreement.completed && work.date_accepted) {
          //     // const invitee = this.props.invites.find(invite => invite.invitee === user);
          //     // userName = invitee.name;
          //     userName = otherInfo.name;
          // }

          if (use_company_name && company_name) {
            userName += ` (${company_name})`;
          }

          let publishers = [];
          if (withPublishers) {
            if (dealOrigin && deal && deal.id === dealOrigin.id) {
              dealUsers = dealUsersOrigin;
            }
            const dealUser = R.find(R.whereEq({ user: user, type: 'member' }))(
              dealUsers
            );
            publishers =
              dealUser && dealUser.publishers ? dealUser.publishers : [];

            if (
              type === 'deal-edit' &&
              dealBlocks &&
              deal &&
              dealOrigin.id === deal.id &&
              (profile.id === user || profile.id === deal.user) &&
              isTestVersion
            ) {
              let dealBlock = R.find(R.propEq('id', PublishesID))(dealBlocks);

              if (dealBlock && dealBlock.changes && dealBlock.changes.adjust) {
                publishers = R.filter(
                  (publisher) => publisher.userId === user,
                  dealBlock.changes.publishers
                );
              }
            }
          }

          const filteredRoles = R.filter(
            (role) => work.type === role.work_type,
            roles
          );

          rows.push(
            <tr key={i}>
              <td>{userName}</td>
              <td>{getRoleNames(role_ids, filteredRoles).join(', ')}</td>
              <td>{getOwnershipTypeName(ownership_type, ownershipTypes)}</td>
              <td>{percentage}%</td>
              {agreement.type === 'premium' && (
                <td>{licenserIds.indexOf(user) !== -1 ? 'Yes' : 'No'}</td>
              )}
            </tr>
          );
          i++;

          publishers.forEach(({ publisher_name, society, publisher_share }) => {
            if (publisher_name || society || publisher_share) {
              rows.push(
                <tr key={i}>
                  <td></td>
                  <td></td>
                  <td>
                    {society.length > 0 ? (
                      <div key={i} className="nowrap">
                        {' '}
                        - {publisher_name}({society})
                      </div>
                    ) : (
                      <div key={i} className="nowrap">
                        {' '}
                        - {publisher_name}
                      </div>
                    )}
                  </td>
                  <td>
                    <div key={i} className="nowrap">
                      {' '}
                      - Pub Share: {parseFloat(publisher_share, 10) || 0}%
                    </div>
                  </td>
                  {agreement.type === 'premium' && <td />}
                </tr>
              );
              i++;
            }
          });
        }
      );

      let isRevenue = false;
      if (
        fields.soundRecordingType === 'revenue' ||
        (work && work['sound_recording_type'] === 'revenue')
      ) {
        isRevenue = true;
      }

      return (
        <div>
          <div className="user-status">
            <table>
              <thead>
                <tr>
                  <th>Contributors</th>
                  <th>Role</th>
                  <th>{isRevenue ? 'Copyright Type' : 'Ownership Type'}</th>
                  <th>{isRevenue ? 'Revenue Type' : 'Ownership Split'}</th>
                  {agreement.type === 'premium' && (
                    <th>Permission to License</th>
                  )}
                </tr>
              </thead>
              <tbody>{rows}</tbody>
            </table>
          </div>

          {dateEffect ? (
            isAmmend ? (
              <p className="small">
                * The parties agreed to amend this agreement with the additional
                works above on {dateEffect}
              </p>
            ) : null
          ) : (
            <p className="small">* NOT ACCEPTED BY ALL COLLABORATORS YET</p>
          )}
        </div>
      );
    }
  }

  renderCreateWork() {
    const { fields, workTypes, subWorkTypes, type, tabName } = this.props;

    let workTypeName = '';
    let subWorkTypeName = '';
    let withPublishers = false;

    if (type === 'create') {
      if (fields.type) {
        workTypeName = getWorkTypeNameById(fields.type, workTypes);
        withPublishers = workTypeName === 'Music';
      }
      if (fields.subtype) {
        subWorkTypeName = getSubWorkTypeNameById(fields.subtype, subWorkTypes);
      }

      const blockSelected =
        tabName === 'Overview' ||
        tabName === 'Publishers' ||
        tabName === 'LicensingPermissions';

      return (
        <div
          className={`work-not-accepted ${
            blockSelected ? 'block-selected' : ''
          }`}
        >
          <p>
            <label>
              <label className="fixed">Work:</label>
              {fields.name}
            </label>
            <br />
            <label>
              <label className="fixed">Type of Work:</label>
              {workTypeName}, {subWorkTypeName}
            </label>
          </p>
          {this.renderCreateWorkOwnership(withPublishers)}
        </div>
      );
    }
  }

  renderCreateWorkOwnership(withPublishers) {
    const {
      workOwnerships,
      roles,
      agreement,
      ownershipTypes,
      contractBlocks,
      members,
      fields,
    } = this.props;
    let licenserIds = agreement.licenser_ids || [];
    const block = R.find(R.propEq('name', 'Licensing Permissions'))(
      contractBlocks
    );

    if (block && block.options) {
      licenserIds = block.options.licenserIds || [];
    }

    if (workOwnerships && workOwnerships.length) {
      let i = 0;
      const rows = [];
      workOwnerships.forEach(
        ({ user, ownership_type, percentage, role_ids }) => {
          let userName = '';
          const member = getMemberByUserId(user, members);

          if (member && member.user_info) {
            userName = member.user_info.name;

            if (
              member.user_info.use_company_name &&
              member.user_info.company_name
            ) {
              userName += ` (${member.user_info.company_name})`;
            }
          }

          let publishers = [];
          if (withPublishers) {
            const memberPublisher = R.find(R.propEq('user', user))(
              fields.memberPublishers || []
            );
            publishers =
              memberPublisher && memberPublisher.publishers
                ? memberPublisher.publishers
                : [];
          }

          rows.push(
            <tr key={i}>
              <td>{userName}</td>
              <td>{getRoleNames(role_ids, roles).join(', ')}</td>
              <td>{getOwnershipTypeName(ownership_type, ownershipTypes)}</td>
              <td>{percentage}%</td>
              {agreement.type === 'premium' ? (
                <td>{licenserIds.indexOf(user) !== -1 ? 'Yes' : 'No'}</td>
              ) : null}
            </tr>
          );
          i++;

          publishers.forEach(({ publisherName, society, publisher_share }) => {
            if (publisherName || society || publisher_share) {
              rows.push(
                <tr key={i}>
                  <td></td>
                  <td></td>
                  <td>
                    <div key={i} className="nowrap">
                      {' '}
                      - {publisherName}({society})
                    </div>
                  </td>
                  <td>
                    <div key={i} className="nowrap">
                      {' '}
                      - Pub Share: {parseFloat(publisher_share, 10) || 0}%
                    </div>
                  </td>
                  {agreement.type === 'premium' ? <td></td> : null}
                </tr>
              );
              i++;
            }
          });
        }
      );

      return (
        <div>
          <div className="user-status">
            <table>
              <thead>
                <tr>
                  <th>Contributors</th>
                  <th>Role</th>
                  <th>
                    {fields.soundRecordingType === 'revenue'
                      ? 'Copyright Type'
                      : 'Ownership Type'}
                  </th>
                  <th>
                    {fields.soundRecordingType === 'revenue'
                      ? 'Revenue Type'
                      : 'Ownership Split'}
                  </th>
                  {agreement.type === 'premium' ? (
                    <th>Permission to License</th>
                  ) : null}
                </tr>
              </thead>
              <tbody>{rows}</tbody>
            </table>
          </div>

          <p className="small">* NOT ACCEPTED BY ALL COLLABORATORS YET</p>
        </div>
      );
    }
  }

  loadAgreementText() {
    const {
      contractBlocks,
      type,
      agreement,
      agreementContractBlocks,
      dealBlocks,
      works,
      members,
      isTestVersion,
    } = this.props;

    // Set effective date
    let dateEffect = moment().format('dddd, MMMM Do, YYYY');
    if (type !== 'create') {
      dateEffect = moment(agreement.date_created).format('dddd, MMMM Do, YYYY');
    }

    // Generate signee copy from deal users who have signed the agreement
    let sigUsers = [];
    let contractText = '';
    let deals = agreement.deals || [];
    let dealUsers = this.props.dealUsers || [];

    if (type !== 'create') {
      deals = R.filter((deal) => deal.progress === 100, deals);
      dealUsers = deals.length ? deals[0].deal_users || [] : [];

      dealUsers.forEach((dealUser) => {
        if (dealUser.status === 'Accepted') {
          const invitee = this.props.invites.find(
            (invite) => invite.invitee === dealUser.user
          );
          const member = getMemberByUserId(dealUser.user, members);
          let user = null;
          if (member && member.hasOwnProperty('user_info')) {
            user = member.user_info;
          }
          let userInfo = {};

          if (user) {
            const deal = R.find(R.propEq('id', dealUser.deal))(deals);
            if (deal) {
              const work = R.find(R.propEq('id', deal.work))(works);

              if (work) {
                const ownerships = work.work_ownership_info || [];
                const ownership = R.find(R.propEq('user', dealUser.user))(
                  ownerships
                );

                if (ownership) {
                  if (agreement.completed) {
                    userInfo = {
                      ...ownership,
                      // name: invitee.name,
                      // address: user.address,
                      // city: user.city,
                      // state: user.state,
                      // postal: user.postal,
                      // country: user.country,
                      email: user.email,
                      name:
                        ownership.name === '' ? invitee.name : ownership.name,
                      address:
                        ownership.address === ''
                          ? user.address
                          : ownership.address,
                      city: ownership.city === '' ? user.city : ownership.city,
                      state:
                        ownership.state === '' ? user.state : ownership.state,
                      postal:
                        ownership.postal === ''
                          ? user.postal
                          : ownership.postal,
                      country:
                        ownership.country === ''
                          ? user.country
                          : ownership.country,
                    };
                  } else {
                    userInfo = {
                      use_company_name: ownership.use_company_name,
                      company_name: ownership.company_name,
                      user_title: ownership.user_title,
                      email: user.email,
                      name: invitee.name,
                      address: user.address,
                      city: user.city,
                      state: user.state,
                      postal: user.postal,
                      country: user.country,
                    };
                  }
                }
              }
            }

            sigUsers.push({
              user,
              dealUser,
              ...userInfo,
            });
          }
        }
      });

      let counter = 0;

      sigUsers.forEach((sigUser) => {
        counter++;

        let sigUserName = sigUser['name'];

        if (sigUser['use_company_name'] && sigUser['company_name']) {
          sigUserName = sigUser['company_name'];
        }

        contractText +=
          sigUserName +
          ' having an address at ' +
          sigUser['address'] +
          ', ' +
          sigUser['city'] +
          ', ' +
          sigUser['state'] +
          ' ' +
          sigUser['postal'];

        if (counter === sigUsers.length) {
          contractText += '.';
        } else {
          if (counter === sigUsers.length - 1) {
            contractText += ' and ';
          } else {
            contractText += ', ';
          }
        }
      });
    }

    const options = {
      dateEffect,
      contractText,
      sigUsers,
    };

    if (agreement.type === 'premium') {
      if (contractBlocks.length) {
        contractBlocks.forEach((block, i) => {
          let content = block.content || '';
          let changeOptions = block.options;

          if (type !== 'create' && agreementContractBlocks) {
            let index = R.findIndex(R.propEq('contract_block', block.id))(
              agreementContractBlocks
            );
            if (index !== -1) {
              content = agreementContractBlocks[index].content;
              changeOptions = JSON.parse(
                agreementContractBlocks[index].options
              );
            }
          }

          if (type === 'deal-edit' && dealBlocks && isTestVersion) {
            let index = R.findIndex(R.propEq('id', block.id))(dealBlocks);
            if (index !== -1 && dealBlocks[index].changes) {
              const blockContent = getContent(
                block.name,
                dealBlocks[index].changes,
                {
                  type: agreement.type,
                  state: getState(
                    !isTestVersion,
                    contractBlocks,
                    agreementContractBlocks,
                    dealBlocks
                  ),
                }
              );
              content = blockContent.content;
              changeOptions = dealBlocks[index].changes;
            }
          }

          if (
            block.name === 'Dispute Resolution' &&
            changeOptions &&
            isTestVersion
          ) {
            const blockContent = getContent(block.name, changeOptions, {
              state: getState(
                !isTestVersion,
                contractBlocks,
                agreementContractBlocks,
                dealBlocks
              ),
            });
            content = blockContent.content;
          }

          options[block.name] = content;
        });
      }
      return this.renderTemplate(options);
    } else {
      return (
        <div>
          <p>
            This agreement can be signed in counterparts and by electronic means
            via services provided by Cosynd, Inc. and our signature below will
            indicate our agreement to the above.
          </p>
          {this.renderSignatures(sigUsers)}
        </div>
      );
    }
  }

  renderTemplate = (options) => {
    const props = {
      type: this.props.type,
      completed: this.props.agreement && this.props.agreement.completed,
      editable: this.props.editable,
      tabName: this.props.tabName,
      isCurrentVersion: this.props.isCurrentVersion,
    };

    return (
      <div>
        <p>
          This agreement can be signed in counterparts and by electronic means
          via services provided by Cosynd, Inc. and our signature below will
          indicate our agreement to the above.
        </p>
        <p>
          This agreement (the “Agreement”) is entered into on{' '}
          {options['dateEffect']} by and between {options['contractText']}
        </p>
        <p>
          For good and valuable consideration, the receipt and sufficiency of
          which are hereby acknowledged, the parties hereby agree as follows:
        </p>

        <AgreementSection section="Confidentiality title" {...props}>
          {`<h5>1. Confidentiality</h5>`}
        </AgreementSection>
        <AgreementSection section="Confidentiality" {...props}>
          Neither party shall disclose to any third party any information to
          which such Party has had or will have access to concerning this
          Agreement and/or the Work(s), except as expressly permitted by the
          other Party/Parties in writing, as required by law, and to agents,
          managers, attorneys and other representatives of the disclosing Party
          who require such information.
        </AgreementSection>

        <AgreementSection section="Name & Likeness title" {...props}>
          {props.type === 'create'
            ? `<h5 class="Name&Likeness">2. Name and Likeness </h5>`
            : `<h5>2. Name and Likeness </h5>`}
        </AgreementSection>
        <AgreementSection section="Name&Likeness" {...props}>
          {options['Name & Likeness']}
        </AgreementSection>

        <AgreementSection section="Indemnification title" {...props}>
          {props.type === 'create'
            ? `<h5 class="Indemnification">3. Indemnification</h5>`
            : `<h5>3. Indemnification</h5>`}
        </AgreementSection>
        <AgreementSection section="Indemnification" {...props}>
          {options['Indemnification']}
        </AgreementSection>

        <AgreementSection section="Cure; Remedies title" {...props}>
          {props.type === 'create'
            ? `<h5 class="Cure;Remedies">4. Cure; Remedies</h5>`
            : `<h5>4. Cure; Remedies</h5>`}
        </AgreementSection>
        <AgreementSection section="Cure;Remedies" {...props}>
          {options['Cure; Remedies']}
        </AgreementSection>

        <AgreementSection section="Governing Law title" {...props}>
          {props.type === 'create'
            ? `<h5 class="GoverningLaw">5. Governing Law</h5>`
            : `<h5>5. Governing Law</h5>`}
        </AgreementSection>
        <AgreementSection section="GoverningLaw" {...props}>
          {options['Governing Law']}
        </AgreementSection>

        <AgreementSection section="Notices title" {...props}>
          {`<h5>6. Notices</h5>`}
        </AgreementSection>
        <AgreementSection section="Notices" {...props}>
          Except as otherwise set forth in this Agreement, all notices that
          either of the Parties may desire to serve upon the other shall be in
          writing and may be served by personal delivery, electronic mail, or
          certified or registered mail addressed to the respective party at the
          address set forth on the first page hereof, or such other address as
          said party may from time to time designate in writing. The date of
          personal delivery, mailing, or email of such notice will be deemed the
          date of the serving said notice, statement or payment.
        </AgreementSection>

        <AgreementSection section="Dispute Resolution title" {...props}>
          {props.type === 'create'
            ? `<h5 class="DisputeResolution">7. Dispute Resolution</h5>`
            : `<h5>7. Dispute Resolution</h5>`}
        </AgreementSection>
        <AgreementSection section="DisputeResolution" {...props}>
          {options['Dispute Resolution']}
        </AgreementSection>

        <AgreementSection section="Waiver title" {...props}>
          {`<h5>8. Waiver</h5>`}
        </AgreementSection>
        <AgreementSection section="Waiver" {...props}>
          No term or provision of this Agreement shall be deemed waived and no
          breach excused unless such waiver or consent shall be in writing
          signed and dated by the Party claimed to have waived or consented.
        </AgreementSection>

        <AgreementSection
          section="Relationship of the Parties title"
          {...props}
        >
          {`<h5>9. Relationship of the Parties</h5>`}
        </AgreementSection>
        <AgreementSection section="Relationship of the Parties" {...props}>
          The Parties shall have the relationship of independent contractors,
          and nothing in this Agreement shall be construed to place the Parties
          in the relationship of partners or joint venturers and neither party
          shall have the power to obligate or bind the other Party in any manner
          unless otherwise agreed in writing. Each party is solely responsible
          for filing all of its own tax returns, tax declarations and tax
          schedules and for the payment of all taxes (including without
          limitation social security taxes, federal, state and city income
          taxes, and sales and use taxes) required where due.
        </AgreementSection>

        <AgreementSection section="Additional Documents title" {...props}>
          {`<h5>10. Additional Documents</h5>`}
        </AgreementSection>
        <AgreementSection section="Additional Documents" {...props}>
          Each Party must execute all additional documents and take all actions
          as are reasonably requested by the other Parties in order to complete
          or confirm the transactions contemplated by this Agreement.
        </AgreementSection>

        <AgreementSection section="Reservation of Rights title" {...props}>
          {`<h5>11. Reservation of Rights</h5>`}
        </AgreementSection>
        <AgreementSection section="Reservation of Rights" {...props}>
          Any rights not expressly granted by a Party to this Agreement are
          reserved to that Party. Without limiting the foregoing, nothing in
          this Agreement shall be construed to prevent the Parties from creating
          a work not involving any other Party.
        </AgreementSection>

        <AgreementSection section="Successors and Assigns title" {...props}>
          {`<h5>12. Successors and Assigns</h5>`}
        </AgreementSection>
        <AgreementSection section="Successors and Assigns" {...props}>
          This Agreement shall be binding on any successors of the Parties. No
          Party shall have the right to assign its interests in or obligations
          under this Agreement to any other Party or third party, unless the
          prior written consent of the other Parties is obtained.
        </AgreementSection>

        <AgreementSection section="Entire Agreement title" {...props}>
          {`<h5>13. Entire Agreement</h5>`}
        </AgreementSection>
        <AgreementSection section="Entire Agreement" {...props}>
          This Agreement contains the entire understanding of the Parties
          relating to the subject matter herein contained and cannot be changed
          or terminated orally. Amendments to this Agreement shall be valid only
          if made in writing and agreed to by each of the Parties. This
          Agreement may be executed in counterparts, including by facsimile or
          other electronic means, each of which shall be deemed an original and
          all of which, when taken together, shall constitute one and the same
          instrument.
        </AgreementSection>

        <AgreementSection section="Section Headings title" {...props}>
          {`<h5>14. Section Headings</h5>`}
        </AgreementSection>
        <AgreementSection section="Section Headings" {...props}>
          Paragraph headings hereof are inserted only for the purpose of
          convenient reference. Such headings shall not be deemed to govern,
          limit, modify, or in any other manner affect the scope, meaning, or
          intent of the provisions of this Agreement, or any part or portion
          thereof, nor shall they otherwise be given any legal effect.
        </AgreementSection>

        <AgreementSection
          section="Severability of Invalid Provisions title"
          {...props}
        >
          {`<h5>15. Severability of Invalid Provisions</h5>`}
        </AgreementSection>
        <AgreementSection
          section="Severability of Invalid Provisions"
          {...props}
        >
          To the extent that any provision of this Agreement shall be determined
          to be invalid or unenforceable, the validity and enforceability of the
          remainder of such provision of this Agreement shall be unaffected. In
          the event any of the provisions are held invalid, illegal, or
          unenforceable, the Parties shall endeavor through good-faith
          negotiations to agree on a valid or enforceable provision which shall
          be a reasonable substitute in light of the tenor of the Agreement as
          originally executed and amended or modified form time to time prior to
          the determination of invalidity or unenforceability.
        </AgreementSection>

        <p>
          <b>
            Each Party hereby acknowledges and agrees that he or she has had the
            opportunity to consult with independent counsel of such Party’s own
            choice experienced in matters in connection with this Agreement,
            that any failure to do so is knowing and willful, and that this
            Agreement is the product of informed negotiation, and as such, shall
            not be construed against the drafter. Each Party further
            acknowledges and agrees that he or she has read and fully
            understands this Agreement, the contents hereof, and the legal
            consequences thereof.
          </b>
        </p>

        <p>
          This agreement can be signed in counterparts and by electronic means
          via services provided by Cosynd, Inc. and our signature below will
          indicate our agreement to the above.
        </p>

        {this.renderSignatures(options['sigUsers'])}
      </div>
    );
  };

  renderSignatures = (sigUsers) =>
    sigUsers.map((sigUser, i) => {
      if (sigUser['use_company_name']) {
        return (
          <div className="sig-block" key={sigUser['dealUser']['id']}>
            <div className="deal-user-info">
              <span className="deal-user-name">
                <strong>{sigUser['company_name']}</strong>
              </span>
            </div>
            <div className="sig-holder">
              <img src={sigUser['dealUser']['signature']} role="presentation" />
            </div>
            <div className="deal-user-info">
              <span className="deal-user-name">
                <strong>By {sigUser['name']}</strong>
              </span>
              <span className="deal-user-email">
                It's {sigUser['user_title']}
              </span>
              <span className="deal-user-email">{sigUser['email']}</span>
              <span className="deal-user-address">{sigUser['address']}</span>
              <span className="deal-user-address">
                {sigUser['city']
                  ? `${sigUser['city']}, ${sigUser['state']} ${sigUser['postal']}`
                  : `${sigUser['state']} ${sigUser['postal']}`}
              </span>
            </div>
          </div>
        );
      } else {
        return (
          <div className="sig-block" key={sigUser['dealUser']['id']}>
            <div className="sig-holder">
              <img src={sigUser['dealUser']['signature']} role="presentation" />
            </div>
            <div className="deal-user-info">
              <span className="deal-user-name">
                <strong>{sigUser['name']}</strong>
              </span>
              <span className="deal-user-email">{sigUser['email']}</span>
              <span className="deal-user-address">{sigUser['address']}</span>
              <span className="deal-user-address">
                {sigUser['city']
                  ? `${sigUser['city']}, ${sigUser['state']} ${sigUser['postal']}`
                  : `${sigUser['state']} ${sigUser['postal']}`}
              </span>
            </div>
          </div>
        );
      }
    });

  render() {
    const { type, agreement, works, fields } = this.props;

    let dateEffect = moment().format('dddd, MMMM Do, YYYY');
    if (type !== 'create') {
      dateEffect = moment(agreement.date_created).format('dddd, MMMM Do, YYYY');
    }

    let isRevenue = false;
    if (
      fields.soundRecordingType === 'revenue' ||
      (works &&
        works.length > 0 &&
        works[0]['sound_recording_type'] === 'revenue')
    ) {
      isRevenue = true;
    }

    return (
      <div className="agreement-text">
        <div className="subheading">
          {isRevenue ? 'REVENUE SPLIT AGREEMENT' : 'OWNERSHIP SPLIT AGREEMENT'}
        </div>

        <p className="text-right">Dated: Effective as of {dateEffect}</p>
        {type === 'create' || works.length ? (
          <p>
            The following is agreed upon ownership splits with respect to the
            following work(s):
          </p>
        ) : null}

        {this.renderCreateWork()}
        {this.renderWorks()}
        {this.loadAgreementText()}
      </div>
    );
  }
}

AgreementTextPremiumSplit.defaultProps = {
  works: [],
  isTestVersion: true,
};

const mapStateToProps = (state, props) => ({
  fields: state.create.fields,
  roles: state.global.roles,
  ownershipTypes: state.global.ownershipTypes,
  contractBlocks: state.global.contractBlocks,
  workTypes: state.global.workTypes,
  subWorkTypes: state.global.subWorkTypes,
  agreementContractBlocks: state.agreements.contractBlocks,
  dealBlocks: selectDealBlocksState(state, props),
  deal: state.deals.selectedDeal,
  agreement: state.agreements.selectedAgreement,
  members: state.users.members,
  workOwnerships: state.workOwnerships.workOwnerships,
  dealUsers: state.dealUsers.dealUsers,
  profile: state.profile,
  invites: state.invites.invites,
});

export default connect(mapStateToProps)(AgreementTextPremiumSplit);



// WEBPACK FOOTER //
// src/components/Agreements/AgreementTextPremiumSplit.jsx